import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { POSTS } from "../data/blog";

export default function Blog() {
  return (
    <div data-testid="blog-page" className="pt-32 md:pt-44">
      <Seo
        title="Journal | Quexify Real Estate Operations"
        description="Practical notes on running a tighter real estate pipeline, transaction coordination, and closing more deals with less chasing."
        path="/blog"
      />
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <h1 className="font-display text-5xl md:text-8xl tracking-tighter font-medium leading-[0.9] max-w-4xl">
            Notes on running a tighter pipeline.
          </h1>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="border-t border-black/10">
          {POSTS.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.05}>
              <Link to={`/blog/${post.slug}`} className="group grid md:grid-cols-12 gap-6 py-12 border-b border-black/10 items-start" data-testid={`blog-card-${i}`}>
                <div className="md:col-span-3 text-sm text-neutral-400">{post.readTime}</div>
                <div className="md:col-span-7">
                  <h2 className="font-display text-3xl md:text-4xl tracking-tight font-medium group-hover:opacity-60 transition-opacity">{post.title}</h2>
                  <p className="mt-4 text-neutral-500 text-lg leading-relaxed max-w-2xl">{post.excerpt}</p>
                </div>
                <div className="md:col-span-2 md:text-right"><ArrowUpRight className="inline-block transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" /></div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
